import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import AppCell from '@/components/common/app-cell';
import Toggle from '@/components/common/toggle';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import useGroupInfo from '@/hooks/groups/use-group-info';
import useUpdateGroupAllBan from '@/hooks/groups/use-update-group-allban';
import useUpdateGroupDetails from '@/hooks/groups/use-update-group-details';
import ROUTES from '@/routes';

export default function GroupAdminIndexRoute() {
  const { t } = useTranslation();
  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN);
  const { data: groupInfo } = useGroupInfo(groupId);
  const { mutateAsync: updateGroup, isPending: isUpdatingGroup } = useUpdateGroupDetails(groupId);
  const { mutateAsync: updateGroupAllBan, isPending: isUpdatingGroupAllBan } = useUpdateGroupAllBan(groupId);

  const handleUpdateAddFriend = (allow: boolean) => updateGroup({ AddFriend: allow ? 1 : 0 });

  return (
    <PageLayout
      title={t('conversation.setting.group.admin.title')}
      headerConfig={{
        navigateBack: true,
      }}>
      <div className='mx-2 flex flex-col'>
        <Link to={ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.$.ADMINS.$path({ relative: true })}>
          <AppCell
            label={t('conversation.setting.group.admin.administrators')}
            chevron
          />
        </Link>

        <AppCell
          label={t('conversation.setting.group.admin.no-add-friend')}
          labelWrapperClassName='min-w-0 whitespace-break-spaces'
          suffix={
            <Toggle
              checked={!groupInfo?.GroupData?.AddFriend}
              isLoading={isUpdatingGroup}
              onChange={(value) => handleUpdateAddFriend(!value)}
            />
          }
        />

        <AppCell
          label={t('conversation.setting.group.admin.ban-all')}
          suffix={
            <Toggle
              checked={groupInfo?.GroupData?.AllBan}
              isLoading={isUpdatingGroupAllBan}
              onChange={(value) => updateGroupAllBan(value)}
            />
          }
        />
      </div>
    </PageLayout>
  );
}
